// Single neutral default thumbnail for any item with no uploaded image.
// Inline SVG data URI so it renders instantly on every surface (catalogue,
// new-order grid, item picker, edit form) with zero network requests and stays
// crisp at any size. Deliberately generic - an "add a photo" frame that suits a
// cafe, a retail shop, or a service business equally (no food/utensil imagery).
//
// Stored value stays NULL in the DB; this default is applied at render time
// only, so no item row ever carries this string (no DB bloat).

const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120'>
  <rect width='120' height='120' rx='18' fill='#f0fdf4'/>
  <g fill='none' stroke='#34d399' stroke-width='4.5' stroke-linecap='round' stroke-linejoin='round'>
    <rect x='30' y='34' width='60' height='52' rx='9'/>
    <circle cx='47' cy='51' r='5.5'/>
    <path d='M33 80 L54 60 L66 71 L77 62 L87 71'/>
  </g>
</svg>`;

export const DEFAULT_ITEM_IMAGE = `data:image/svg+xml,${encodeURIComponent(svg)}`;
